import styled from 'styled-components'

const StyledCommunity = styled.div`
  position: relative;
`

export default StyledCommunity
